import { ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryCollections = ErrorBoundary;
